import React from "react";
import { cssHeightValues, cssTopValues } from "../../../../constants/layout";

export const FlapComponent = ({
  index,
  styles = {},
  children = null,
  currentStep,
}) => {
  const openFlapBackground =
    "transparent linear-gradient(0deg, #DBE5F4 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box";
  const closedFlapBackground =
    "transparent linear-gradient(0deg, #cceefc 0%, #b9e6fb 100%) 0% 0% no-repeat padding-box";
  const closedFlapStyles = {
    transition: "all 300ms ease-in-out 0s",
    height: "25%",
    background: closedFlapBackground,
    borderRadius: "0px 0px 0px 66px",
    // mixBlendMode: "hard-light",
    boxShadow: "0px 1px 2px #9dc4d5",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    // paddingBottom: "2rem",
    width: "100%",
    position: "absolute",
    right: "0",
  };
  return (
    <div
      style={{
        zIndex: 600 - index * 100,

        ...closedFlapStyles,
        ...styles,
        top: cssTopValues[currentStep][index],
        height: cssHeightValues[currentStep][index],
      }}
    >
      {children}
    </div>
  );
};
